import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuditTrailSearchService } from './audit-trail-search.service';

@Component({
  selector: 'dl-audit-trail-search',
  templateUrl: './audit-trail-search.component.html',
  styleUrls: ['./audit-trail-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditTrailSearchComponent implements OnInit {

  public constructor(private auditTrailSearchService: AuditTrailSearchService) { }

  public auditTrailSearch = new FormControl();

  public ngOnInit(): void {}

  public applyFilter(filterValue: string): void {
    // console.log('search value', filterValue);
    this.auditTrailSearchService.getSearchedData(filterValue.trim().toLocaleLowerCase());
  }

}
